import React, { useContext } from 'react';
import { Box, Optional } from '@honda-canada/design-system-react';

import FooterContext from '../service/FooterContext';
import GeoLocator from '../shared/GeoLocator';
import SocialMediaLinks from '../shared/SocialMediaLinks';
import themeStyles from '../Footer.styles';

const SectionDivider = themeStyles.apply(Box, 'SectionDivider');
const TopContainer = themeStyles.apply(Box, 'TopContainer');

const MenuTop = () => {
  const { mobileLocationAtTop, mobileSocialAtTop, showGeoLocator, socialMediaSection, styles } =
    useContext(FooterContext);

  return (
    <Optional when={mobileSocialAtTop || (mobileLocationAtTop && showGeoLocator)}>
      <TopContainer styles={styles.topContainerMobile}>
        <Optional when={mobileLocationAtTop && showGeoLocator}>
          <GeoLocator />
          <SectionDivider />
        </Optional>
        <Optional when={mobileSocialAtTop}>
          <SocialMediaLinks data={socialMediaSection} />
        </Optional>
      </TopContainer>
    </Optional>
  );
};

export default MenuTop;
